/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Triple_H_Description1Inputs */

const en_map_triple_h_description1 = /** @type {(inputs: Map_Triple_H_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industrial site with three activity zones.`)
};

const fr_map_triple_h_description1 = /** @type {(inputs: Map_Triple_H_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site industriel à trois zones d'activité.`)
};

const ms_sg2_map_triple_h_description1 = /** @type {(inputs: Map_Triple_H_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapak perindustrian dengan tiga zon aktiviti.`)
};

/**
* | output |
* | --- |
* | "Industrial site with three activity zones." |
*
* @param {Map_Triple_H_Description1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
const map_triple_h_description1 = /** @type {((inputs?: Map_Triple_H_Description1Inputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Triple_H_Description1Inputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_triple_h_description1(inputs)
	if (locale === "fr") return fr_map_triple_h_description1(inputs)
	return ms_sg2_map_triple_h_description1(inputs)
});
export { map_triple_h_description1 as "map_triple_H_description" }